import { z } from 'zod'

export const clientCreateSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Invalid email'),
  company_name: z.string().optional(),
  phone: z.string().optional(),
  country: z.enum(['US', 'UK']).optional(),
  website_url: z.string().url().optional(),
  subscription_tier: z.enum(['basic', 'growth']).optional(),
  design_type: z.enum(['single', 'ab']).optional(),
  monthly_amount: z.number().positive().optional(),
})

export const clientUpdateSchema = clientCreateSchema.partial()

export const clientResponseSchema = z.object({
  id: z.string(),
  client_number: z.string(),
  name: z.string(),
  company_name: z.string().nullable(),
  email: z.string(),
  phone: z.string().nullable(),
  country: z.string().nullable(),
  website_url: z.string().nullable(),
  created_at: z.string(),
  subscription_tier: z.string(),
  design_type: z.string(),
  monthly_amount: z.number().nullable(),
})
